import { fade } from '@material-ui/core';
import token from '@uipath/apollo-core';
export const MuiAutocomplete = (palette) => {
    return {
        root: {
            color: palette.semantic.colorForeground,
            '&$disabled': { color: palette.semantic.colorForegroundDisable },
            '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
                paddingTop: '2.38px',
                paddingBottom: '2px',
            },
        },
        paper: { boxShadow: token.Shadow.ShadowDp8 },
        listbox: { background: palette.semantic.colorBackgroundRaised },
        option: {
            background: palette.semantic.colorBackgroundRaised,
            fontSize: token.FontFamily.FontMSize,
            lineHeight: token.FontFamily.FontMLineHeight,
            '&:hover': {
                backgroundColor: palette.semantic.colorHover,
                color: palette.semantic.colorForegroundDeEmp,
            },
            '&:focus': {
                backgroundColor: fade(palette.semantic.colorPrimary, 0.1),
                color: palette.semantic.colorForegroundDeEmp,
            },
            '&$selected': {
                boxShadow: `inset 4px 0px 0px ${palette.semantic.colorForegroundHigh}`,
                backgroundColor: fade(palette.semantic.colorForegroundHigh, 0.1),
                color: palette.semantic.colorForegroundDeEmp,
            },
            '&$selected:hover': {
                boxShadow: `inset 4px 0px 0px ${palette.semantic.colorForegroundHigh}`,
                backgroundColor: fade(palette.semantic.colorForegroundHigh, 0.15),
                color: palette.semantic.colorForegroundDeEmp,
            },
        },
        groupUl: {
            background: palette.semantic.colorBackgroundRaised,
            boxShadow: token.Shadow.ShadowDp8,
        },
    };
};
